import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\components\\BlogCategory.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\components\\BlogDetail.js");
